/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResourceAudienceRolePlugin = {
  /**
   * Plugin name.
   */
  name: string;
  /**
   * Plugin ID.
   */
  pluginId: string;
  /**
   * Exact role assigned to the plugin.
   */
  principalUrn: string;
  /**
   * Plugin slug.
   */
  slug: string;
};

/** @internal */
export const ResourceAudienceRolePlugin$inboundSchema: z.ZodMiniType<
  ResourceAudienceRolePlugin,
  unknown
> = z.pipe(
  z.object({
    name: z.string(),
    plugin_id: z.string(),
    principal_urn: z.string(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "plugin_id": "pluginId",
      "principal_urn": "principalUrn",
    });
  }),
);

export function resourceAudienceRolePluginFromJSON(
  jsonString: string,
): SafeParseResult<ResourceAudienceRolePlugin, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResourceAudienceRolePlugin$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResourceAudienceRolePlugin' from JSON`,
  );
}
